<div class="login-container">
  <p-toast></p-toast>

  <div class="login-card">
    <div class="login-card-isotipo">
      <img src="img/logo.png" alt="Logo">
    </div>
    
    <div class="p-inputgroup cursor-pointer">
      <span (click)="goBack()" class="p-inputgroup-addon">
        <i class="pi pi-arrow-left"></i>
      </span>
      <label class="login-subtitle"> Restablecer contraseña</label>
    </div>

    <p class="login-description">
      Ingresa tu correo electrónico para iniciar el proceso de recuperación de contraseña.
    </p>

    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
      <div class="input-group">
        <label class="input-label">Correo electrónico</label>
        <input
          pInputText
          type="email"
          formControlName="email"
          placeholder="ejemplo@mail.com"
          class="custom-input"
          (blur)="f['email'].markAsTouched()"
          [ngClass]="{ 'input-error': f['email'].errors && (f['email'].touched || f['email'].dirty || submitted) }"
        >
        <div *ngIf="f['email'].errors && (f['email'].touched || f['email'].dirty || submitted)" class="error-message">
          <div *ngIf="f['email'].errors['required']">El correo electrónico es requerido</div>
          <div *ngIf="f['email'].errors['email'] || f['email'].errors['customEmail']">Ingresa un correo electrónico válido</div>
        </div>
      </div>

      <button 
        pButton 
        type="submit" 
        class="login-button"
        [disabled]="loading || loginForm.invalid"
      >
        <i *ngIf="loading" class="pi pi-spin pi-spinner" style="margin-right: 0.5rem;"></i>
        <span *ngIf="!loading">Enviar</span>
        <span *ngIf="loading">Enviando...</span>
      </button>
    </form>
  </div>
  <p-toast></p-toast>
</div>
